document.addEventListener("DOMContentLoaded", () => {

  const btnShowHide = document.querySelector(".hdr_cd_nav_show_btn");
  const divToHandle = document.querySelector(".hdr_cd_nav_filters");
  
  btnShowHide.addEventListener("click", () => {
    if (btnShowHide.textContent === "Show More") {
      btnShowHide.textContent = "Show Less";
      divToHandle.style.height = "auto";
    } else {
      btnShowHide.textContent = "Show More";
      divToHandle.style.height = "55px";
    }
  });

});